import React, { useMemo } from 'react';

export function StarField({ count = 70 }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2.2 + 0.6,
        dur: Math.random() * 3 + 2,
        delay: Math.random() * 3,
      })),
    [count]
  );
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            '--dur': `${s.dur}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
}

export function AuraLogo({ size = 44, glow = true }) {
  return (
    <div
      className="grid place-items-center rounded-2xl"
      style={{
        width: size,
        height: size,
        background: 'linear-gradient(135deg, #E879F9, #A855F7 55%, #7C3AED)',
        boxShadow: glow ? '0 10px 30px -6px rgba(168,85,247,0.55)' : 'none',
      }}
    >
      <i className="fa-solid fa-heart text-white" style={{ fontSize: size * 0.42 }} />
    </div>
  );
}
